import { CommonRecord, CommonState } from './common.state';
import * as actions from './common.action';
import { PostModel } from './models/post.model';
import { CategoryModel } from './models/category.model';
import { TagModel } from './models/tag.model';

export const initialState: CommonState = (new CommonRecord() as unknown) as CommonState;

export function reducer(state = initialState, { type, payload }: any): CommonState {
    if (!type) {
        return state;
    }

    switch (type) {
        case actions.ActionTypes.GET_POST_LIST: {
            return Object.assign({}, state, {
                getPostListLoading: true,
                getPostListData: null,
                getPostListFailData: null,
                getPostListDataAmount: 0
            });
        }
        case actions.ActionTypes.GET_POST_LIST_SUCCESS: {
            let data = [];
            let amount = 0;
            let err;
            if (payload.data && payload.data.posts && payload.success) {
                data = payload.data.posts.map((item: any) => new PostModel(item));
                amount = payload.data.amount ? payload.data.amount : 0;
            } else {
                err = payload;
            }
            return Object.assign({}, state, {
                getPostListLoading: false,
                getPostListData: data,
                getPostListFailData: err,
                getPostListDataAmount: amount
            });
        }
        case actions.ActionTypes.GET_POST_LIST_FAIL: {
            return Object.assign({}, state, {
                getPostListLoading: false,
                getPostListData: null,
                getPostListFailData: payload,
                getPostListDataAmount: 0
            });
        }

        case actions.ActionTypes.GET_POST_ITEM: {
            return Object.assign({}, state, {
                getPostItemLoading: true,
                getPostItemData: null,
                getPostItemFailData: null,
            })
        }
        case actions.ActionTypes.GET_POST_ITEM_SUCCESS: {
            let item: PostModel;
            if (payload.data && payload.success) {
                item = new PostModel(payload.data);
            }
            return Object.assign({}, state, {
                getPostItemLoading: false,
                getPostItemData: item,
                getPostItemFailData: null,
            })
        }
        case actions.ActionTypes.GET_POST_ITEM_FAIL: {
            return Object.assign({}, state, {
                getPostItemLoading: false,
                getPostItemData: null,
                getPostItemFailData: payload,
            })
        }
        case actions.ActionTypes.CLEAR_GET_POST_ITEM_STATE: {
            return Object.assign({}, state, {
                getPostItemLoading: false,
                getPostItemData: null,
                getPostItemFailData: null,
            })
        }

        case actions.ActionTypes.REMOVE_POST_ITEM: {
            return Object.assign({}, state, {
                removePostItemLoading: true,
                removePostItemData: null,
                removePostItemFailData: null,
            })
        }
        case actions.ActionTypes.REMOVE_POST_ITEM_SUCCESS: {
            return Object.assign({}, state, {
                removePostItemLoading: false,
                removePostItemData: payload,
                removePostItemFailData: null,
            })
        }
        case actions.ActionTypes.REMOVE_POST_ITEM_FAIL: {
            return Object.assign({}, state, {
                removePostItemLoading: false,
                removePostItemData: null,
                removePostItemFailData: payload,
            })
        }
        case actions.ActionTypes.CLEAR_REMOVE_POST_ITEM_STATE: {
            return Object.assign({}, state, {
                removePostItemLoading: false,
                removePostItemData: null,
                removePostItemFailData: null,
            })
        }

        case actions.ActionTypes.CREATE_POST_ITEM: {
            return Object.assign({}, state, {
                createPostItemLoading: true,
                createPostItemData: null,
                createPostItemFailData: null
            })
        }
        case actions.ActionTypes.CREATE_POST_ITEM_SUCCESS: {
            let data;
            let err;
            if (payload.success && payload.data) {
                data = new PostModel(payload.data)
            } else {
                err = payload;
            }

            return Object.assign({}, state, {
                createPostItemLoading: false,
                createPostItemData: data,
                createPostItemFailData: err
            })
        }
        case actions.ActionTypes.CREATE_POST_ITEM_FAIL: {
            return Object.assign({}, state, {
                createPostItemLoading: false,
                createPostItemData: null,
                createPostItemFailData: payload
            })
        }
        case actions.ActionTypes.CLEAR_CREATE_POST_ITEM_STATE: {
            return Object.assign({}, state, {
                createPostItemLoading: false,
                createPostItemData: null,
                createPostItemFailData: null
            })
        }

        case actions.ActionTypes.UPDATE_POST_ITEM: {
            return Object.assign({}, state, {
                updatePostItemLoading: true,
                updatePostItemData: null,
                updatePostItemFailData: null
            })
        }
        case actions.ActionTypes.UPDATE_POST_ITEM_SUCCESS: {
            return Object.assign({}, state, {
                updatePostItemLoading: false,
                updatePostItemData: payload,
                updatePostItemFailData: null
            })
        }
        case actions.ActionTypes.UPDATE_POST_ITEM_FAIL: {
            return Object.assign({}, state, {
                updatePostItemLoading: false,
                updatePostItemData: null,
                updatePostItemFailData: payload
            })
        }
        case actions.ActionTypes.CLEAR_UPDATE_POST_ITEM_STATE: {
            return Object.assign({}, state, {
                updatePostItemLoading: false,
                updatePostItemData: null,
                updatePostItemFailData: null
            })
        }

        case actions.ActionTypes.GET_CATEGORY_ITEM: {
            return Object.assign({}, state, {
                getCategoryItemLoading: true,
                getCategoryItemData: null,
                getCategoryItemFailData: null,
            })
        }
        case actions.ActionTypes.GET_CATEGORY_ITEM_SUCCESS: {
            let data;
            let err;
            if (payload.data && payload.success) {
                data = new CategoryModel(payload.data);
            } else {
                err = payload;
            }

            return Object.assign({}, state, {
                getCategoryItemLoading: false,
                getCategoryItemData: data,
                getCategoryItemFailData: err,
            })
        }
        case actions.ActionTypes.GET_CATEGORY_ITEM_FAIL: {
            return Object.assign({}, state, {
                getCategoryItemLoading: false,
                getCategoryItemData: null,
                getCategoryItemFailData: payload,
            })
        }
        case actions.ActionTypes.CLEAR_GET_CATEGORY_ITEM_STATE: {
            return Object.assign({}, state, {
                getCategoryItemLoading: false,
                getCategoryItemData: null,
                getCategoryItemFailData: null,
            })
        }

        case actions.ActionTypes.GET_CATEGORY_LIST: {
            return Object.assign({}, state, {
                getCategoryListLoading: true,
                getCategoryListData: null,
                getCategoryListFailData: null,
            })
        }
        case actions.ActionTypes.GET_CATEGORY_LIST_SUCCESS: {
            let data;
            let err;
            if (payload.data && !!payload.data.length && payload.success) {
                data = payload.data.map((el: any) => new CategoryModel(el));
            } else {
                err = payload;
            }
            return Object.assign({}, state, {
                getCategoryListLoading: false,
                getCategoryListData: data,
                getCategoryListFailData: err,
            })
        }
        case actions.ActionTypes.GET_CATEGORY_LIST_FAIL: {
            return Object.assign({}, state, {
                getCategoryListLoading: false,
                getCategoryListData: null,
                getCategoryListFailData: payload,
            })
        }

        case actions.ActionTypes.CREATE_TAG_ITEM: {
            return Object.assign({}, state, {
                createTagItemLoading: true,
                createTagItemData: null,
                createTagItemFailData: null,
            })
        }
        case actions.ActionTypes.CREATE_TAG_ITEM_SUCCESS: {
            return Object.assign({}, state, {
                createTagItemLoading: false,
                createTagItemData: payload,
                createTagItemFailData: null,
            })
        }
        case actions.ActionTypes.CREATE_TAG_ITEM_FAIL: {
            return Object.assign({}, state, {
                createTagItemLoading: false,
                createTagItemData: null,
                createTagItemFailData: payload,
            })
        }
        case actions.ActionTypes.CLEAR_CREATE_TAG_ITEM_FAIL: {
            return Object.assign({}, state, {
                createTagItemLoading: false,
                createTagItemData: null,
                createTagItemFailData: null,
            })
        }

        case actions.ActionTypes.UPDATE_TAG_ITEM: {
            return Object.assign({}, state, {
                updateTagItemLoading: true,
                updateTagItemData: null,
                updateTagItemFailData: null,
            })
        }
        case actions.ActionTypes.UPDATE_TAG_ITEM_SUCCESS: {
            return Object.assign({}, state, {
                updateTagItemLoading: false,
                updateTagItemData: payload,
                updateTagItemFailData: null,
            })
        }
        case actions.ActionTypes.UPDATE_TAG_ITEM_FAIL: {
            return Object.assign({}, state, {
                updateTagItemLoading: false,
                updateTagItemData: null,
                updateTagItemFailData: payload,
            })
        }
        case actions.ActionTypes.CLEAR_UPDATE_TAG_ITEM_STATE: {
            return Object.assign({}, state, {
                updateTagItemLoading: false,
                updateTagItemData: null,
                updateTagItemFailData: null,
            })
        }

        case actions.ActionTypes.REMOVE_TAG_ITEM: {
            return Object.assign({}, state, {
                removeTagItemLoading: true,
                removeTagItemData: null,
                removeTagItemFailData: null,
            })
        }
        case actions.ActionTypes.REMOVE_TAG_ITEM_SUCCESS: {
            return Object.assign({}, state, {
                removeTagItemLoading: false,
                removeTagItemData: payload,
                removeTagItemFailData: null,
            })
        }
        case actions.ActionTypes.REMOVE_TAG_ITEM_FAIL: {
            return Object.assign({}, state, {
                removeTagItemLoading: false,
                removeTagItemData: null,
                removeTagItemFailData: payload,
            })
        }
        case actions.ActionTypes.CLEAR_REMOVE_TAG_ITEM_FAIL_STATE: {
            return Object.assign({}, state, {
                removeTagItemLoading: false,
                removeTagItemData: null,
                removeTagItemFailData: null,
            })
        }

        case actions.ActionTypes.GET_TAG_ITEM: {
            return Object.assign({}, state, {
                getTagItemLoading: true,
                getTagItemData: null,
                getTagItemFailData: null,
            })
        }
        case actions.ActionTypes.GET_TAG_ITEM_SUCCESS: {
            return Object.assign({}, state, {
                getTagItemLoading: false,
                getTagItemData: payload,
                getTagItemFailData: null,
            })
        }
        case actions.ActionTypes.GET_TAG_ITEM_FAIL: {
            return Object.assign({}, state, {
                getTagItemLoading: false,
                getTagItemData: null,
                getTagItemFailData: payload,
            })
        }
        case actions.ActionTypes.CLEAR_GET_TAG_ITEM_STATE: {
            return Object.assign({}, state, {
                getTagItemLoading: false,
                getTagItemData: null,
                getTagItemFailData: null,
            })
        }

        case actions.ActionTypes.GET_TAG_LIST: {
            return Object.assign({}, state, {
                getTagListLoading: true,
                getTagListData: null,
                getTagListFailData: null,
            })
        }
        case actions.ActionTypes.GET_TAG_LIST_SUCCESS: {
            let data;
            let err;
            if (payload.success && payload.data && !!payload.data.length) {
                data = payload.data.map((el: any) => new TagModel(el));
            } else {
                err = payload
            }
            return Object.assign({}, state, {
                getTagListLoading: false,
                getTagListData: data,
                getTagListFailData: err,
            })
        }
        case actions.ActionTypes.GET_TAG_LIST_FAIL: {
            return Object.assign({}, state, {
                getTagListLoading: false,
                getTagListData: null,
                getTagListFailData: payload,
            })
        }
        case actions.ActionTypes.CLEAR_GET_TAG_LIST_STATE: {
            return Object.assign({}, state, {
                getTagListLoading: false,
                getTagListData: null,
                getTagListFailData: null,
            })
        }

        case actions.ActionTypes.REMOVE_IMAGE_FROM_POST: {
            return Object.assign({}, state, {
                removeImageFromPostLoading: true,
                removeImageFromPostData: null,
                removeImageFromPostFailData: null
            })
        }
        case actions.ActionTypes.REMOVE_IMAGE_FROM_POST_FAIL: {
            return Object.assign({}, state, {
                removeImageFromPostLoading: false,
                removeImageFromPostData: null,
                removeImageFromPostFailData: payload
            })
        }
        case actions.ActionTypes.REMOVE_IMAGE_FROM_POST_SUCCESS: {
            return Object.assign({}, state, {
                removeImageFromPostLoading: false,
                removeImageFromPostData: payload,
                removeImageFromPostFailData: null
            })
        }
        case actions.ActionTypes.CLEAR_REMOVE_IMAGE_FROM_POST_STATE: {
            return Object.assign({}, state, {
                removeImageFromPostLoading: false,
                removeImageFromPostData: null,
                removeImageFromPostFailData: null
            })
        }

        default: {
            return state;
        }
    }
}

export const getPostListLoading = (state: CommonState) => state.getPostListLoading;
export const getPostListData = (state: CommonState) => state.getPostListData;
export const getPostListFailData = (state: CommonState) => state.getPostListFailData;
export const getPostListDataAmount = (state: CommonState) => state.getPostListDataAmount;

export const getPostItemLoading = (state: CommonState) => state.getPostItemLoading;
export const getPostItemData = (state: CommonState) => state.getPostItemData;
export const getPostItemFailData = (state: CommonState) => state.getPostItemFailData;

export const removePostItemLoading = (state: CommonState) => state.removePostItemLoading;
export const removePostItemData = (state: CommonState) => state.removePostItemData;
export const removePostItemFailData = (state: CommonState) => state.removePostItemFailData;

export const createPostItemLoading = (state: CommonState) => state.createPostItemLoading;
export const createPostItemData = (state: CommonState) => state.createPostItemData;
export const createPostItemFailData = (state: CommonState) => state.createPostItemFailData;

export const updatePostItemLoading = (state: CommonState) => state.updatePostItemLoading;
export const updatePostItemData = (state: CommonState) => state.updatePostItemData;
export const updatePostItemFailData = (state: CommonState) => state.updatePostItemFailData;

export const getCategoryItemLoading = (state: CommonState) => state.getCategoryItemLoading;
export const getCategoryItemData = (state: CommonState) => state.getCategoryItemData;
export const getCategoryItemFailData = (state: CommonState) => state.getCategoryItemLoading;

export const getCategoryListLoading = (state: CommonState) => state.getCategoryListLoading;
export const getCategoryListData = (state: CommonState) => state.getCategoryListData;
export const getCategoryListFailData = (state: CommonState) => state.getCategoryListFailData;

export const createTagItemLoading = (state: CommonState) => state.createTagItemLoading;
export const createTagItemFailData = (state: CommonState) => state.createTagItemFailData;
export const createTagItemData = (state: CommonState) => state.createTagItemData;

export const updateTagItemLoading = (state: CommonState) => state.updateTagItemLoading;
export const updateTagItemFailData = (state: CommonState) => state.updateTagItemFailData;
export const updateTagItemData = (state: CommonState) => state.updateTagItemData;

export const removeTagItemLoading = (state: CommonState) => state.removeTagItemLoading;
export const removeTagItemFailData = (state: CommonState) => state.removeTagItemFailData;
export const removeTagItemData = (state: CommonState) => state.removeTagItemData;

export const getTagItemLoading = (state: CommonState) => state.getTagItemLoading;
export const getTagItemFailData = (state: CommonState) => state.getTagItemFailData;
export const getTagItemData = (state: CommonState) => state.getTagItemData;

export const getTagListLoading = (state: CommonState) => state.getTagListLoading;
export const getTagListFailData = (state: CommonState) => state.getTagListFailData;
export const getTagListData = (state: CommonState) => state.getTagListData;

export const removeImageFromPostLoading = (state: CommonState) => state.removeImageFromPostLoading;
export const removeImageFromPostData = (state: CommonState) => state.removeImageFromPostData;
export const removeImageFromPostFailData = (state: CommonState) => state.removeImageFromPostFailData;